import React from "react";
import { Grid, Paper, Toolbar } from "@mui/material";
import { styled } from "@mui/material/styles";

import { LanguageMenu } from "src/components/header/LanguageMenu";
import logo from "src/assets/images/atmo-plan-logo-filled.png";
import bg from "src/assets/images/login-bg.png";
import { Spacer } from "src/components/Spacer";
import { HelpMenu } from "src/components/header/HelpMenu";

interface Props {
  children: React.ReactNode;
}

export const AuthLayout = (props: Props) => {
  return (
    <StyledGrid container className="root">
      <Grid item xs={false} sm={6} className="cover" />
      <Grid item xs={12} sm={6} component={Paper} square elevation={6} className="content">
        <Toolbar className="toolbar">
          <img src={logo} alt="" className="logo" />
          <Spacer />
          <LanguageMenu />
          <HelpMenu />
        </Toolbar>
        {props.children}
      </Grid>
    </StyledGrid>
  );
};

const StyledGrid = styled(Grid)`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: row;

  .content {
    position: relative;
  }

  .logo {
    position: absolute;
    left: 0;
    top: 0;
    height: 70px;
  }

  .root {
    height: 100%;
  }
  .cover {
    background-image: url(${bg});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
`;
